import React, { ReactNode } from 'react';

import { CardLabel, CardValue } from 'common/components/Card/card.styled';
import { Item } from 'common/components/Card/PageDetailsCard/PageDetailsCard.styled';

interface IRrops {
  label?: ReactNode;
  value?: string | number;
  children?: ReactNode;
  highlight?: boolean;
  padding?: string;
}

export const PageDetailsCardItem = ({
  label,
  value,
  children,
  padding,
  highlight = false,
}: IRrops) => {
  return (
    <Item padding={padding}>
      {label && <CardLabel $isBold={highlight}>{label}</CardLabel>}
      {value && <CardValue>{value}</CardValue>}
      {children}
    </Item>
  );
};
